export default __webpack_public_path__ + "static/media/news87.5bde1aa6.jpg";